<div>
    <mat-toolbar>
        <mat-toolbar-row>
            <div class="logo">
                <a [routerLink]="['/invoices']">
                    <img src="./assets/img/logo_tenaris.png" alt="Tenaris">
                </a>
                <span *ngIf="isScreenSmall" class="logo-title">INVOICING PORTAL</span>
            </div>

            <ng-container *ngIf="!isScreenSmall">
                <span class="separator">|</span>
                <span class="title">INVOICING PORTAL</span>
            </ng-container>

            <span class="example-spacer"></span>
            <span class="user mat-subheading-2 mr-sm-2">{{ name | uppercase
                }}</span>

            <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>menu</mat-icon>
            </button>
            <mat-menu class="menu" #menu="matMenu">
                <button mat-menu-item [routerLink]="['/invoices']">INVOICES</button>
                <button
                    mat-menu-item
                    [routerLink]="['/customers']"
                    *ngIf="canViewCustomers"
                >
                    CUSTOMERS
                </button>
                <button mat-menu-item (click)="logout()">LOGOUT</button>
            </mat-menu>
        </mat-toolbar-row>
    </mat-toolbar>
</div>